module.exports = __webpack_public_path__ + "static/video-b00e2a4c75d3b68d8104705d739654ee.svg";